var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"pr-lg-0 px-0 px-sm-3",attrs:{"cols":"12","lg":"3"}},[_c('InPageNavigationMobile',{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"items":_vm.items}}),_c('InPageNavigationDesktop',{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }